import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, inject, provideEnvironmentInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { setLicenseKey as setWijmoLicenseKey } from '@grapecity/wijmo';
import player from 'lottie-web';
import { CookieService } from 'ngx-cookie-service';
import { provideLottieOptions } from 'ngx-lottie';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/models/auth.interceptor';
import { BrandService } from './core/services/brand.service';
import { HeapAnalyticsService } from './core/services/heap-analytics.service';
import { ScreenBreakpointService } from './core/services/screen-breakpoint.service';
import { SessionRefreshService } from './core/services/session-refresh.service';
import { SessionService } from './core/services/session.service';
import { InstitutionService } from './shared/services/institutions.service';

export const appConfig: ApplicationConfig = {
	providers: [
		CookieService,
		provideRouter(routes),
		provideZoneChangeDetection(),
		provideLottieOptions({ player: () => import('lottie-web') }),
		provideHttpClient(withInterceptorsFromDi()),
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		provideAnimations(),
		provideLottieOptions({
			player: () => player,
		}),
		provideEnvironmentInitializer(() => {
			inject(ScreenBreakpointService);
			inject(SessionService);
			inject(SessionRefreshService);
			inject(BrandService);
			inject(HeapAnalyticsService);

			// Pre-load institutions
			void firstValueFrom(inject(InstitutionService).institutions$);

			setWijmoLicenseKey(
				'uat.trovata.io|d4.trovata.io|jp-morgan.trovata.io|nab.trovata.io|wf-multibank.trvta.com|d5.trovata.io|d1.trovata.io|dev.nab.trovata.io|beta.trovata.io|d2.trovata.io|dev.trovata.io|small-business.trovata.io|w1.trovata.io|d3.trovata.io|widget-dev.trovata.io|widget.trovata.io|app.trovata.io|wfuat-multibank.trvta.com,588473142314533#B0Sd52WauEGdhZ7byRnLiFmbs2WauEGdhZ7byRnLuF6Zy3WbtAnas2WauEGdhZ7byRnL4QGLvlmLhRXY63mc49CdhVnI0IyctRkIsIyYulEIhRXY63mcUJiOiEmTDJCLiMzM5QTMzIDNxMzN4gDO5IiOiQWSiwSfdtlOicGbmJCLiEjd5IDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPnJDNXxkc7BjSHRlN94GUtVHMspFbQhzcaNUc4AjblljZpZVWxc6LzJkNidkesRDZ5smS9cHOil4MTJ5ZoFkNatGOQFDewoENLN5LGhFW05kQro7SNRzMY94MxR5UTJVcpNWQvcjYSljeKlWW79meF3Gc5lGMKhmNqV6SnZUV5MTVRV6SEh7d59me584bwoVRMJWQst6QEZHTNdUdvMDczJ4KEZDTJZ6MzRXdXJmWiZVemtUWtJzMIBHcxcEZuRVWCN7S7QGcDlXT4FHShFzQyY6artSUKZlYRd5ZK3STE5ka9c6MYtkdF3kZoNkeJpEeLVzd4kEbTRXRyEFOrdUdu96KxYEeLNWaVZ6ardHWxMTNopWTyJFOUZzR7JFaENGO8tmdpRVRzhDNXdnWMRTbyg7Kp3CWPdkc8l5KElkMhxEd6oGaHRHe44EUzpVc6NzRnVXd8tGViojITJCLiMTM9UTOzMzMiojIIJCLwITMwEjMxETO0IicfJye=#Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI5EjMzkDMgkDMyETNyAjMiojI4J7QiwiIt36YuEGd6JHdusmbhJWa4xWdt5CdhVnZ7xybp9SY4FmdvJHduAHchxybp9SY4FmdvJHduQXZnRWa7xybp9SY4FmdvJHduYXZk5CdldGZpdHLvlmLhRXY63mc49yMkxybp9SY4FmdvJHduEzds2WauEGdhZ7byRnLzNXZul6c5JWLsxWYtNHLvlmLhRXY63mc49idlRGLvlmLhRXY63mc49iMkxybp9SY4FmdvJHduEGdlJGLvlmLhRXY63mc49iYh9mL6VGZs2WauEGdhZ7byRnLxQGLvlmLhRXY63mc49SNkxSbvNmLhRndyRnLr9WYilGdsVTbxY'
			);
		}),
	],
};
